import axios from 'axios';
import {addTokenToRequestInterceptorAsync, responseInterceptorAsync} from "@/interceptors/axios";
import {isLocalhost} from "@/common/common";

const { VITE_API_HOST, DEV } = import.meta.env; // env variables

export const axiosConfig = {
  baseURL: DEV || isLocalhost() ? `${VITE_API_HOST}` : `/`,
  timeout: 0,
  headers: {
    accept: '*/*',
    'Content-Type': 'application/json',
  },
};

export const axiosClient = axios.create(axiosConfig);

/** Adds interceptor before sending a request to HdService. Adds access token to all request. */
axiosClient.interceptors.request.use(async (request) => await addTokenToRequestInterceptorAsync(request));


/** Adds interceptor after receiving response from HdService. Adds new access token if response status core equal 401 and send request again. */
axiosClient.interceptors.response.use((response) => response,
    async (error) => await responseInterceptorAsync(error));